/**
 * KEY-754: marks a section or action point that is hidden on this dial and on screen only because the dial admin
 * looking at it asked to see the hidden parts for a while. Nobody else is ever sent a hidden part, so the tag
 * says so — the admin must not mistake it for something the rest of the household can see.
 */
export function HiddenTag({ hidden }: { hidden?: boolean }) {
  if (!hidden) {
    return null;
  }
  return (
    <span
      title="Hidden — only you can see this, for now"
      style={{ flex: "none", fontSize: 10, fontWeight: 800, letterSpacing: "0.04em", textTransform: "uppercase", color: "var(--text-muted)", background: "repeating-linear-gradient(135deg, var(--surface-2) 0 5px, transparent 5px 10px)", border: "var(--border-w) dashed var(--border)", borderRadius: 99, padding: "1px 7px", whiteSpace: "nowrap" }}
    >
      Hidden
    </span>
  );
}
